<template>

  <div>
    <el-row>
      <el-col :span="24">
        <div class="grid-content bg-purple-light">

          <div class="searchTitle">
            <b> 출고 상세 </b>
          </div>

          <!-- 조회 조건 영역 -->
          <div class="searchBody">
            <!-- 조회 조건 영역 -->
            <!--        <div class="searchBody">-->
            <!--          <div class="searchBody_brand">-->
            <!--            출고 출고-->
            <!--          </div>-->
            <!--          <div>-->
            <!--            <el-select v-model="statusOption" placeholder="Select">-->
            <!--              <el-option-->
            <!--                  v-for="item in statusOptions"-->
            <!--                  :key="item.value"-->
            <!--                  :label="item.label"-->
            <!--                  :value="item.value">-->
            <!--              </el-option>-->
            <!--            </el-select>-->
            <!--          </div>-->
            <!--        </div>-->
            <div class="searchBody_production">
              판매 일자
            </div>
            <div>
              <el-date-picker
                  v-model="confirmStartDateOption"
                  type="date"
                  placeholder="Pick a day"
                  value-format="yyyy-MM-dd"
              >
              </el-date-picker>
              ~
              <el-date-picker
                  v-model="confirmEndDateOption"
                  type="date"
                  placeholder="Pick a day"
                  value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </div>
          </div>


          <!-- 조회 조건 영역 -->
          <div class="searchBody">

            <div class="searchBody_brand">
              <el-button
                  :loading="loading"
                  type="primary"
                  @click="search"
              >Search</el-button>
            </div>
          </div>


        </div> <!-- div class="grid-content bg-purple-light"> -->
      </el-col>

    </el-row>



    <el-table
        v-loading="loading"
        ref="multipleTable"
        :data="tableData"

        border
        @selection-change="handleSelectionChange"
        :row-class-name="tableRowClassName"
        size="small"
        :row-style="{height:0+'px'}"
        :cell-style="{padding:0+'px'}"
        :header-cell-style="{background:'#f0f9eb',color:'#606266', height:'10px', padding:'0px'}"
    >
      <el-table-column
          type="selection"
          width="35"
      >
      </el-table-column>

      <!-- data 시작 -->
      <!-- <el-table-column
        label="Date"
        width="120">
        <template slot-scope="scope">{{ scope.row.date }}</template>
      </el-table-column> -->

      <el-table-column
          property="seq"
          label="seq"
          width="50">
      </el-table-column>



      <el-table-column
          property="out_product_date"
          label=" 판매일자"
          width="130">
      </el-table-column>



      <el-table-column
          property="out_product_country"
          label="판매국가"
          width="130">
      </el-table-column>



      <el-table-column
          property="out_product_city"
          label="판매도시"
          width="140">
      </el-table-column>

      <el-table-column
          property="out_product_shop"
          label="판매처명"
          width="140">
      </el-table-column>

      <el-table-column
          property="out_product_name"
          label="판매제품"
          width="140">
      </el-table-column>


      <el-table-column
          property="qr_code"
          label="QR CODE"
          width="300">
      </el-table-column>


    </el-table>




    <el-row>
      <el-col :span="24"><div class="pagination"  >

        <el-pagination
            small

            layout="prev, pager, next"
            :total="totalSize"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="pageSize"
        >
        </el-pagination>

        <el-button
            :loading="loading"
            type="primary"
            @click="excelDownFuncAll"
        > 엑셀 다운로드 (전체)</el-button>

        <el-tag type="warning" effect="dark"  style="margin-left: 10px; height: 30px"> COUNT : {{this.totalData.length}}</el-tag>

        <!--          <el-button-->
<!--            :loading="loading"-->
<!--            type="primary"-->
<!--            @click="print"-->
<!--          >출력</el-button>-->


        <!--    <el-button-->
        <!--    :loading="loading"-->
        <!--    type="primary"-->
        <!--    @click="excelDownFunc"-->
        <!--  > 파일 재생성 </el-button>-->

        <!-- <el-button
      :loading="loading"
      type="primary"
      @click="save(3)"
    >발행결과 업로드(완료)</el-button> -->




        <el-dialog
            title="발행결과 파일 업로드"
            :visible.sync="dialogVisible"
            width="30%"
            v-loading="loading"
            :before-close="Confirm"
        >
    <span class="text-reader">
      <form ref="form">

      <input type="file" @change="filesChange" class="FileUpload__default" accept=".csv" multiple  />
      </form>
    </span>

          <span slot="footer" class="dialog-footer">
    <!-- <el-button @click="dialogVisible = false">Cancel</el-button> -->
    <el-button type="primary" @click="Confirm">Confirm</el-button>
  </span>


        </el-dialog>


      </div>
      </el-col>
    </el-row>

  </div>
</template>


<script>
import Axios from 'axios';
import XLSX from "xlsx";


export default {
  created() {
    this.$store.commit("dayBefore",0);
    this.confirmEndDateOption = this.$store.state.dateOption; // 조회조건에서 현재 날짜 
    this.$store.commit("dayBefore",7);
    this.confirmStartDateOption = this.$store.state.dateOption; // 조회조건이서 현재보다 -7 일
    if (this.$store.state.userId != 'admin') {
      // this.deptSeqOption = this.$store.state.deptSeq;
      // this.deptNameOption = this.$store.state.deptName;
    }

    // console.log()
    // 페이지로딩시 조회
    this.search();
    // this.getFilePath();
  },//created    
  data() {
    return {
      // table 관련 data 
      tableData: [],
      totalData: [],
      multipleSelection: [],
      saveData:[],
      saveData2:[],
      currentPage: 1,
      pageSize:10,
      totalSize:0,

      // loading 변수 true 이면 loging 화면 보여줌
      loading:false,



      statusOptions: [{

        value: 'I',
        label: '출고'
      },
        {
          value: 'O',
          label: '출고'
        }, ],
      brandOption: '',
      styleOption :'',
      deptNameOption:'',
      deptSeqOption:0,
      confirmStartDateOption:'',
      confirmEndDateOption:'',
      statusOption:'출고',
      status:'',
      fileList: [],
      text :[],
      dialogVisible: false,
      statusLavel:'',
      filePath:'',
      epc :'',
      member_id :'',
      member_name : '',
      chkInDate : false,


    } // return 
  },// data

  methods: {

    // async getFilePath() {
    //   this.loading = true;
    //
    //   let url = this.$url + '/fileInfo/list';
    //
    //
    //   await Axios.post(url , "getList", this.$store.state.config ).then(res => {
    //     var resDataJson = res.data
    //     this.filePath = resDataJson;
    //     this.loading = false;
    //   }) // await Axios.post
    //     .catch(error => {
    //     console.log(error.response)
    //     this.$message.error(this.$store.state.serverErrorMessage);
    //     this.loading = false;
    //   }); // await Axios.post
    //
    // },

    print(){

      window.print();
    },

    async search(){
      this.loading = true;

      // default data 
      let url = this.$url + '/rfidInfo/outDetailList';
      var reqJson = new Object();


      reqJson.out_start_date = this.confirmStartDateOption;
      reqJson.out_end_date = this.confirmEndDateOption;
      reqJson.status = 'I';

      reqJson.company_name =  this.$store.state.hospitalname;
      if (this.$store.state.accessToken != '100')
        reqJson.rfid_get_order_seq = this.$store.state.rfid_get_order_seq;

      //console.log("============================")
      //console.log(reqJson.status);

      await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
        var resDataJson = res.data.rfidInfoDTO;
        this.totalData=[];
        this.filePath = res.data.filePath;

        if (res.data.resultCode){

          for (var resData in resDataJson) {


              this.totalData.push({
                seq: resData  * 1 + 1
                , qr_code: resDataJson[resData]['qr_code']
                , out_product_date: resDataJson[resData]['out_product_date']
                , out_product_country: resDataJson[resData]['out_product_country']
                , out_product_city : resDataJson[resData]['out_product_city']
                , out_product_shop: resDataJson[resData]['out_product_shop']
                , out_product_name: resDataJson[resData]['out_product_name']
              });

          }
          // 전체 데이터 사이즈 
          this.totalSize = this.totalData.length;
          // 보여주는 부분만 slice 
          this.tableData = this.totalData.slice(0, this.pageSize);
          this.currentPage = 1;
          this.loading = false;
          this.status = reqJson.status;
          this.$message.success(this.$store.state.searchSuccess);
        }else{
          this.$message.error(this.$store.state.dataNotFound);
          this.currentPage = 1;
          this.loading = false;
        }
      }) // await Axios.post
          .catch(error => {
            console.log(error.response)
            this.$message.error(this.$store.state.serverErrorMessage);
            this.currentPage = 1;
            this.loading = false;
          }); // await Axios.post
    },//search

    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    }, //toggleSelection

    // check box click event 
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    tableRowClassName({row, rowIndex}) {
      if (rowIndex === 1) {
        //  return 'warning-row';
      } else if (rowIndex === 3) {
        //  return 'success-row';
      }
      console.log(row);
      return '';
    },
    handleSizeChange(val) {
      console.log(`${val} items per page`);
    },

    // pagging event 
    handleCurrentChange(val) {
      this.tableData = this.totalData.slice( (this.pageSize * val - this.pageSize )   , this.pageSize * val);
    },

    save(value){

      let url = "";

      if (this.multipleSelection.length <= 0)
      {
        this.$message.error("데이터를 선택하세요 ");
        return ;
      }

      // if (value == 1) // 발행접수
      // {
      //   if (this.status != '1') //status 가 1이어야만저장 가능
      //   {
      //     this.$message.error("확정상테의 데이터만 발행접수가 가능합니다. ");
      //     return ;
      //   }
      //   url = this.$url + '/rfidOrder/rfidReceipt';
      // }else

      if (value == 2){
        // if (this.status != '1')
        // {
        //   this.$message.error("발행접수 상태의 데이터만 발행 시작 가능합니다 . ");
        //   return ;
        // }
        url = this.$url + '/rfidOrder/rfidPublishStart';
      }
      //else if (value == 3){
      //    if (this.status != '3')
      //   {
      //     this.$message.error("발행시작 상태의 데이터만 완료 가능합니다 . ");
      //     return ;
      //   }
      //   url = this.$url + '/rfidOrder/rfidPublishComplete';
      // }

      for(var resData in this.multipleSelection){
        this.multipleSelection[resData]['reg_user_id'] = this.$store.state.userId
        this.multipleSelection[resData]['upd_user_id'] = this.$store.state.userId

        this.multipleSelection[resData]['rfid_order_amount'] =  this.multipleSelection[resData]['rfid_order_amount'] *=1;
        this.multipleSelection[resData]['publish_amount'] =  this.multipleSelection[resData]['publish_amount'] *=1;
        this.multipleSelection[resData]['publish_start_number'] =  this.multipleSelection[resData]['publish_start_number'] *=1;
        this.multipleSelection[resData]['publish_end_number'] =  this.multipleSelection[resData]['publish_end_number'] *=1;


      }


      this.loading = true;
      Axios.post(url, this.multipleSelection , this.$store.state.config  ).then(res => {

        //console.log(res);
        let saveCount = res.data;
        this.loading = false;
        this.$message.success(saveCount +'건 ' + this.$store.state.saveSuccess);
        this.search();

      }).catch(error => {
        console.log(error.response)
        this.$message.error(this.$store.state.serverErrorMessage);
        this.currentPage = 1;
        this.loading = false;
      }); // await Axios.post
    }, // save

    async excelDownFunc(){

      if(this.multipleSelection==null || this.multipleSelection.length == 0 ){
        this.$message.error(this.$store.state.noDataSelect);
        return ;
      }

      this.loading = true;

      // default data
      let url = this.$url + '/rfidInfo/reDowload';
      // var reqJson = new Object();

      await Axios.post(url, this.multipleSelection , this.$store.state.config ).then(res => {
        let saveCount = res.data;


        if (saveCount){
          this.$message.success(saveCount +'건 ' + this.$store.state.saveSuccess);
          this.loading = false;

        }else{
          this.$message.error(this.$store.state.serverErrorMessage);
          this.currentPage = 1;
          this.loading = false;
        }
      }) // await Axios.post
          .catch(error => {
            console.log(error.response)
            this.$message.error(this.$store.state.serverErrorMessage);
            this.currentPage = 1;
            this.loading = false;
          }); // await Axios.post


    }, //excelDownFunc



    async pathUpload(){


      this.loading = true;

      // default data
      let url = this.$url + '/saveInfo/pathUpdate';
      var reqJson = new Object();


      reqJson.file_full_path = this.filePath;

      await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
        let saveCount = res.data;

        if (saveCount){
          this.$message.success(saveCount +'건 ' + this.$store.state.saveSuccess);
          this.loading = false;

        }else{
          this.$message.error(this.$store.state.serverErrorMessage);
          this.currentPage = 1;
          this.loading = false;
        }
      }) // await Axios.post
          .catch(error => {
            console.log(error.response)
            this.$message.error(this.$store.state.serverErrorMessage);
            this.currentPage = 1;
            this.loading = false;
          }); // await Axios.post


    }, //excelDownFunc

    getCheckSum(hex)
    {
      var chk = hex.length
      var value = 0;
      for(var i=0; i <hex.length; i += 2) {
        value +=  parseInt(hex.substring(i, i+2),16) * chk
        chk ++;
      }
      var res = value * 1224 % 100;
      if (res <= 9)
        return '0' + res;
      else
        return res;
    },

    convertToHex(str) {
      var hex = '';
      for(var i=0;i<str.length;i++) {
        hex += str.charCodeAt(i).toString(16);
      }
      return hex;
    },

    convertToString(hex) {

      //console.log("convertToString");
      //console.log(hex);

      var str = '';
      for(var i=0;i<hex.length; i += 2) {
        str += String.fromCharCode(parseInt(hex.substring(i, i+2),16))
      }
      return str;
    },

    filesChange(e) {
      let fileName = e.target.files[0].name
      let lastIndex = fileName.lastIndexOf('.')
      let fileExtension = fileName.substring(lastIndex, fileName.length).toLowerCase()

      if (fileExtension !== '.txt' ||  fileExtension !== '.csv') {
        // this.$alert('텍스트 파일만 업로드 가능합니다.', '알림', { confirmButtonText: '확인' })
        // return
      }

      let fileList = e.target.files
      if (!fileList.length) return

      const reader = new FileReader()
      const file = e.target.files[0];
      reader.onload =  evt => {
        this.text = evt.target.result;
        const textArray = this.text.split('\n');
        // console.log(textArray);

        console.log("======================" + this.text.length );
        if (this.text.length < 10)
        {
          this.$message.error(" 파일 포맷 오류 입니다. ");
          this.$refs.form.reset() ;
          return ;
        }
        const reqJson=[];
        this.loading = true;
        for(var i in textArray){
          if (i==0)
            continue;
          const dataArray = textArray[i].trim().split(',');
          // comma 보다 작으면
          if (dataArray.length  < 2)
          {
            continue;
          }

          var brand  = ""

          //
          // if (dataArray[1].substring(4,18) == "08809658602046")
          // {
          //   brand = 'LS'
          // }else if(dataArray[1].substring(4,18) == "08809550971127"  )
          // {
          //   brand = 'CR'
          // }

          reqJson.push({
            rfid_order_seq :  dataArray[0].trim()
            , epc: dataArray[1].trim()
            , rfid_tag  : "CG" + dataArray[1].trim().substring(4)
            , reg_user_id : this.$store.state.userId
            , brand : brand
            , publish_seq :  dataArray[1].trim().substring(24,30)
            // // , createDate : dataArray[1]
            // , rfid_order_seq : dataArray[2]
            // , style : dataArray[6]
            // , color : dataArray[7]
            // , size : dataArray[8]
            // , order_degree : dataArray[9]
            // , publish_seq: dataArray[10]
            , status:'0'
          });
        }

        //console.log(reqJson);
        let url = "";
        url = this.$url + '/rfidInfo/insert';

        Axios.post(url, reqJson , this.$store.state.config  ).then(res => {

          //console.log(res);
          let saveCount = res.data;
          this.loading = false;
          this.$message.success(saveCount +'건 ' + this.$store.state.saveSuccess);
          this.search();
          // this.$refs.myFiles.files[0].name = null;
        }).catch(error => {
          console.log(error.response)
          this.$message.error(this.$store.state.serverErrorMessage);
          this.currentPage = 1;
          this.loading = false;
        }); // await Axios.post

      }
      reader.readAsText(file)

    },//filesChange

    Confirm(){
      // this.e.target.files[0].name = "";

      this.$refs.form.reset() ;
      this.dialogVisible = false
    },

    submitUpload() {
      this.$refs.upload.submit();
    },


    excelDownFuncAll(){
      var excepData = [];

      for (var i in this.totalData) {
        excepData.push({
          입고날짜 : this.totalData[i]['in_datetime']
          ,출고날짜 : this.totalData[i]['out_datetime']
          ,회사명 : this.totalData[i]['company_name']
          ,QRCODE : this.totalData[i]['qr_code']
        });
      }

      this.loading = true;
      var dataWS = XLSX.utils.json_to_sheet(excepData);
      var wb = XLSX.utils.book_new();
      // workbook에 워크시트 추가
      // 시트명은 'nameData'
      XLSX.utils.book_append_sheet(wb, dataWS, '제품출고내역상세');
      // 엑셀 파일을 내보낸다.
      this.$store.commit("dayBefore",0); // 오늘날짜
      XLSX.writeFile(wb, "제품출고내역상세"+'.csv');
      this.loading = false;
    },//excelDownFunc

  }, //methods
}
</script>

